export default [
  {
    title: '游戏ID',
    key: 'gameId',
    width: 72
  },
  {
    title: '游戏图标',
    key: 'appLogo'
  },
  {
    title: '游戏名称',
    key: 'gameName',
    width: 272
  },
  {
    title: '媒体应用名称',
    key: 'mediaGameName',
    width: 120
  },
  {
    title: '支持媒体',
    key: 'medias',
    width: 90
  },
  {
    title: '创建人',
    key: 'createName',
    width: 90
  },
  {
    title: '更新人',
    key: 'upName',
    width: 90
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 110
  },
  {
    title: '操作',
    key: 'control'
  }
]
